export enum FeatureFlag {
  PureSpectrum = 1
}
